import React, { useEffect, useState } from 'react';
import styles from '../formStyles.module.css';
import FormItem from '@/components/common/FormItem';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import Api from '@/api';
import PlateInput from '@/components/pages/home/HomeContent/HomeHero/PlateLookup/PlateInput';
import MainIcons from '@/icons/main';

export default function FinesWithoutIdentityForm({ info, setInfo }) {
  const tCommon = useTranslations('common');
  let formarray = [
    {
      id: 1,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: tCommon('nationalCode'),
      title: tCommon('nationalCode'),
      error: info?.messages?.national_code,
      // extraInfo: ' * ',
      // styleColor: `starColor`,
      showError: info?.error?.national_code,
      value: info?.national_code,
      key: 'national_code',
      // wrapper: `darkInput`,
    },
    {
      id: 2,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: '7' + '******' + '0912',
      title: tCommon('mobile'),
      error: info?.messages?.mobile,
      value: info?.mobile,
      showError: info?.error?.mobile,
      error: info?.messages?.mobile,
      key: 'mobile',
      // wrapper: `darkInput`,
    },
  ];

  const [formList, setFormList] = useState(formarray);

  useEffect(() => {
    if (info) {
      setFormList(formarray);
    }
  }, [info]);

  const onChange = (value, key) => {
    let valueIs = {
      ...info,
      [key]: value,
      error: {
        ...info?.error,
        [key]: false,
      },
    };

    setInfo(valueIs);
  };

  console.log('info==', info);

  return (
    <>
      <div className={`${styles.plateContainer}`}>
        <PlateInput
          // title={tCommon('enterPlateNum')}
          titleIcon={<MainIcons.notifIcon fill="var(--accent-light)" />}
          callBackInputChange={(x) => onChange(x, 'license_plate_number')}
          inputClass={`${styles.plateInputContainer}`}
          noMaxWidth={true}
        />
        {info?.error?.license_plate_number && info?.messages?.license_plate_number && (
          <p className={`inputErrorText mt-18px`}>{info?.messages?.license_plate_number}</p>
        )}
      </div>
      <div className={`${styles.formContainer}`}>
        {formList?.map((item, index) => (
          <FormItem
            type={item.type}
            inputType={item.inputType}
            key={index}
            item={item}
            index={index}
            onChange={onChange}
            value={info?.[`${item?.key}`]}
          ></FormItem>
        ))}
      </div>
    </>
  );
}
